import { SegmentedTabs } from "@overmap-ai/blocks"
import { memo } from "react"

import { AssetTypeVisibilityTab } from "./Tabs/AssetTypeVisibilityTab"
import { GeoImagesVisibilityTab } from "./Tabs/GeoImagesVisibilityTab"
import { IssueTypeVisibilityTab } from "./Tabs/IssueTypeVisibilityTab"

enum MapVisibilityControlTabs {
	ISSUE_TYPES = "issue_types",
	ASSET_TYPES = "asset_types",
	GEO_IMAGES = "geo_images",
}

export const MapVisibilityControl = memo(() => {
	return (
		<SegmentedTabs.Root
			className="flex size-full flex-col gap-4 overflow-hidden p-4"
			defaultValue={MapVisibilityControlTabs.ASSET_TYPES}
		>
			<div className="flex w-full items-center gap-2">
				<SegmentedTabs.List className="grow" accentColor="base" variant="surface" size="sm">
					<SegmentedTabs.Trigger value={MapVisibilityControlTabs.ASSET_TYPES}>Assets</SegmentedTabs.Trigger>
					<SegmentedTabs.Trigger value={MapVisibilityControlTabs.ISSUE_TYPES}>Issues</SegmentedTabs.Trigger>
					<SegmentedTabs.Trigger value={MapVisibilityControlTabs.GEO_IMAGES}>Images</SegmentedTabs.Trigger>
				</SegmentedTabs.List>
			</div>

			<SegmentedTabs.Content
				className="grow overflow-y-auto overflow-x-hidden"
				value={MapVisibilityControlTabs.ASSET_TYPES}
			>
				<AssetTypeVisibilityTab />
			</SegmentedTabs.Content>
			<SegmentedTabs.Content
				className="grow overflow-y-auto overflow-x-hidden"
				value={MapVisibilityControlTabs.ISSUE_TYPES}
			>
				<IssueTypeVisibilityTab />
			</SegmentedTabs.Content>
			<SegmentedTabs.Content
				className="grow overflow-y-auto overflow-x-hidden"
				value={MapVisibilityControlTabs.GEO_IMAGES}
			>
				<GeoImagesVisibilityTab />
			</SegmentedTabs.Content>
		</SegmentedTabs.Root>
	)
})
MapVisibilityControl.displayName = "MapVisibilityControl"
